import React from 'react';
import PropTypes from 'prop-types';
import autobind from 'react-autobind';
import moment from 'moment';

import Heading from '@hppl/component-heading';
import Link from '@hppl/component-link';
import Panel from '@hppl/component-panel';

const STRINGS = {
	en: { 
		'min': x => `${x} min`,
		'updated': x => `updated ${moment.utc(x).fromNow()}`,
		'error': 'Wait times are currently unavailable.',
		'link': x => `/public/find-care/location-detail.html?networkId=hp&locationId=${x}`
	}
};

const S = (key, ...params) => {
	const s = STRINGS.en[key];
	switch (typeof s) {
		case 'undefined': return key;
		case 'function': return s(...params);
		default: return s;
	}
};


export const WaitTimesView = ({type, title, subtitle, data}) => {
	S('min', 23);
	const age = data && data.updated ? S('updated', data.updated) : '';
	const waitFor = item => {
		if (item.status === 'Closed') return S('Closed');
		if (item.minutes == 0) return S('No wait');
		if (item.minutes < 120) return S('min', item.minutes);
		return S('min', S('120+'));
	};
	
	return (<Panel backgroundColor="panel-primary" heading={title}>
		{ subtitle ? <Heading size="h4" classNames="xs-mt-0" text={subtitle}/> : null }
		{   !data      ? (<Heading size="h5" text={S('error')}/>)
		  : !data.wait ? null
		  : data.wait.map(item => (<div className="row" key={item.lid}>
			<div className="col-xs-8">{ item.lid ? (<Link href={S('link', item.lid)} text={item.name}/>) : item.name }</div>
			<div className="col-xs-4 text-right">{waitFor(item)}</div>
		</div>))}
		<small className="muted">{age}</small>
	</Panel>);
};

class WaitTimes extends React.Component {
	constructor(props) {
		super(props);
		this.state = { };
		autobind(this, 'refreshData');
	}
	
	componentDidMount() {
		this.refreshData();
	}
	
	componentWillUnmount() {
		if (this.timerId) {
			window.clearTimeout(this.timerId);
		}
	}
	
	refreshData() {	
		fetch('/api/wait/v1/' + this.props.type)
			.then(rsp => rsp.json())
			.then(json => this.setState({ data: json }))
			.catch(() => this.setState({ data: null }));
		this.timerId = window.setTimeout(this.refreshData, 30000);
	}
	
	render() {
		return (<WaitTimesView {...this.props} data={this.state.data}/>);
	}
}

WaitTimes.propTypes = {
	type: PropTypes.string.isRequired,
	title: PropTypes.string,
	subtitle: PropTypes.string
};	

WaitTimes.defaultProps = {
	title: '',
	subtitle: ''
};

export default WaitTimes;


// WEBPACK FOOTER //
// ./node_modules/@hpcare/component-wait-times/index.jsx